import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TableField } from '../../entities/form.entity';

@Component({
  selector: 'app-dynamic-table-settings',
  templateUrl: './dynamic-table-settings.component.html',
  styleUrl: './dynamic-table-settings.component.scss'
})
export class DynamicTableSettingsComponent implements OnInit {
  tableField!: TableField;
  index = -1;
  constructor(
    public dialogRef: MatDialogRef<DynamicTableSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.tableField) {
      this.tableField = data.tableField;
      if (!this.tableField.size) {
        this.tableField.size = '100';
      }
    }
    this.index = data.index;
  }

  ngOnInit() {
    if (!this.tableField.data_type) {
      this.tableField.data_type = 'alphanumeric';
    }

    if (this.tableField.enable_totals === undefined) {
      this.tableField.enable_totals = false;
    }

    if (this.tableField.enable_row_totals === undefined) {
      this.tableField.enable_row_totals = false;
    }

    if (
      this.tableField.data_type === 'alphanumeric' &&
      !this.tableField.max_characters
    ) {
      this.tableField.max_characters = 50;
    }

    if (this.tableField.data_type === 'dropdown') {
      this.ensureDropdownDefaults();
    }
  }

  onDataTypeChange(dataType: string): void {
    this.tableField.data_type = dataType;
    if (dataType === 'dropdown') {
      this.ensureDropdownDefaults();
    }
  }

  onUseOptionKeysChange(value: string | boolean): void {
    const enabled = value === true || value === 'true';
    this.tableField.use_option_keys = enabled;
    if (enabled) {
      this.ensureOptionKeysAligned();
    }
  }

  addOption(): void {
    if (!this.tableField.options) {
      this.tableField.options = [];
    }
    this.tableField.options.push('');
    if (this.tableField.use_option_keys) {
      this.ensureOptionKeysAligned();
    }
  }

  deleteOption(optionIndex: number): void {
    if (!this.tableField.options) {
      return;
    }
    this.tableField.options.splice(optionIndex, 1);
    if (this.tableField.use_option_keys && this.tableField.option_keys) {
      this.tableField.option_keys.splice(optionIndex, 1);
    }
  }

  haveEmptyOption(): boolean {
    const options = this.tableField.options || [];
    if (options.some((option) => !option || option.trim() === '')) {
      return true;
    }
    if (this.tableField.use_option_keys) {
      const keys = this.tableField.option_keys || [];
      return keys.some((key) => !key || key.trim() === '');
    }
    return false;
  }

  trackByIndex(index: number): number {
    return index;
  }

  close(): void {
    document.body.focus();
    this.dialogRef.close({ action: 'close' });
  }

  private ensureDropdownDefaults(): void {
    this.tableField.editable = true;
    if (!this.tableField.options) {
      this.tableField.options = [];
    }

    const legacyKeys = (this.tableField as any).optionKeys;
    if (
      Array.isArray(legacyKeys) &&
      !Array.isArray(this.tableField.option_keys)
    ) {
      this.tableField.option_keys = [...legacyKeys];
      delete (this.tableField as any).optionKeys;
    }

    this.tableField.use_option_keys =
      this.tableField.use_option_keys === true ||
      String(this.tableField.use_option_keys) === 'true';

    if (this.tableField.placeholder === undefined) {
      this.tableField.placeholder = 'Select...';
    }
    if (this.tableField.use_option_keys) {
      this.ensureOptionKeysAligned();
    }
  }

  private ensureOptionKeysAligned(): void {
    if (!Array.isArray(this.tableField.option_keys)) {
      this.tableField.option_keys = [];
    }
    const optionsLength = this.tableField.options?.length || 0;
    while (this.tableField.option_keys.length < optionsLength) {
      this.tableField.option_keys.push('');
    }
  }
}
